var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0799 6.38312H7.10529V27.2643H30.0799V6.38312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1977 18.605C37.1977 28.8667 28.8736 37.1852 18.605 37.1852C8.33659 37.1852 0.0123901 28.8667 0.0123901 18.605C0.0123901 8.34338 8.33659 0.0247192 18.605 0.0247192C28.8736 0.0247192 37.1977 8.34338 37.1977 18.605ZM13.3364 25.999H9.7281C8.96988 25.999 8.59536 25.999 8.367 25.853C8.12034 25.6932 7.96962 25.4285 7.95135 25.1363C7.93763 24.8671 8.12492 24.5383 8.49945 23.8811L17.4088 8.18754C17.7879 7.52112 17.9797 7.18791 18.2218 7.06468C18.4822 6.93232 18.7928 6.93232 19.0531 7.06468C19.2952 7.18791 19.487 7.52112 19.8661 8.18754L21.6977 11.3826L21.707 11.399C22.1165 12.1139 22.3241 12.4764 22.4148 12.8569C22.5153 13.2723 22.5153 13.7105 22.4148 14.1259C22.3234 14.5093 22.1179 14.8745 21.7023 15.6002L17.0224 23.8674L17.0103 23.8885C16.5981 24.6094 16.3892 24.9747 16.0998 25.2503C15.7846 25.5517 15.4055 25.7706 14.9898 25.8941C14.6107 25.999 14.186 25.999 13.3364 25.999ZM22.4486 25.999H27.6189C28.3816 25.999 28.7654 25.999 28.9939 25.8486C29.2405 25.6887 29.3957 25.4193 29.4096 25.1274C29.4227 24.8668 29.2395 24.5509 28.8805 23.9318C28.8681 23.9107 28.8557 23.8893 28.8431 23.8675L26.2533 19.44L26.2238 19.3901C25.8599 18.7751 25.6762 18.4645 25.4402 18.3445C25.18 18.2121 24.8738 18.2121 24.6136 18.3445C24.376 18.4677 24.1842 18.7918 23.8051 19.4445L21.2245 23.872L21.2156 23.8873C20.8379 24.539 20.6491 24.8646 20.6627 25.1318C20.681 25.424 20.8317 25.6932 21.0783 25.853C21.3021 25.999 21.6858 25.999 22.4486 25.999Z",
    fill: "#E84142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.21,
    height: 37.21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/avax.4def4696bb9f564bf144cb62eab29b90.svg";
export { ForwardRef as ReactComponent };